import React from 'react';
import { Container, Card, CardContent, Typography, Box } from '@mui/material';
import TopBar from '../components/TopBar';
import '../App.css';

const TermsOfService = () => {
  return (
    <Container component="main" maxWidth="md">
      <TopBar />
      <Card sx={{ mt: 8, p: 3, mb: 4 }}>
        <CardContent>
          <Typography component="h1" variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
            Terms of Service
          </Typography>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            <b>Last updated: January 2025</b>
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              1. Acceptance of Terms
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              By accessing and using Clearance Scouts ("the App"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              2. Use License
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Permission is granted to temporarily use Clearance Scouts for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 3 }}>
              <li><Typography variant="body1">Modify or copy the materials</Typography></li>
              <li><Typography variant="body1">Use the materials for any commercial purpose or for any public display</Typography></li>
              <li><Typography variant="body1">Attempt to reverse engineer any software contained in Clearance Scouts</Typography></li>
              <li><Typography variant="body1">Remove any copyright or other proprietary notations from the materials</Typography></li>
            </Box>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              3. User Content
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              You are responsible for any content you post, including event listings, photos, and comments. You agree not to post content that is:
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 3 }}>
              <li><Typography variant="body1">False, misleading, or fraudulent</Typography></li>
              <li><Typography variant="body1">Illegal, harmful, or violates any laws</Typography></li>
              <li><Typography variant="body1">Infringes on intellectual property rights</Typography></li>
              <li><Typography variant="body1">Contains spam, viruses, or malicious code</Typography></li>
            </Box>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              4. Location Services
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Clearance Scouts uses location services to show you relevant deals in your area. By using the App, you consent to the collection and use of your location data as described in our Privacy Policy.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              5. Account Responsibility
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              6. Disclaimer
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              The information on Clearance Scouts is provided on an "as is" basis. We do not guarantee the accuracy, completeness, or timeliness of event listings. Users should verify all information before making purchasing decisions.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              7. Limitation of Liability
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              In no event shall Clearance Scouts or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the App.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              8. Modifications
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Clearance Scouts may revise these terms of service at any time without notice. By using this App you are agreeing to be bound by the then current version of these terms of service.
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              9. Contact Information
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              If you have any questions about these Terms of Service, please contact us at BransonRideshare@gmail.com.
            </Typography>
          </Box>
          
          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider', textAlign: 'center' }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
              © 2026 Mark Forsythe. All Rights Reserved.
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default TermsOfService;

